"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLATFORM_ID = void 0;
var PLATFORM_ID = {
  DESKTOP: 49,
  MOBILEWEB: 67
};
exports.PLATFORM_ID = PLATFORM_ID;